import {AfterViewInit, Component, ElementRef, Input, OnInit, Output, Renderer2} from '@angular/core';
import {EventEmitter} from 'protractor';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {InfoBoxHtmlContent} from '../../models/settings/casual-portal/app-setting';

@Component({
  selector: 'opt-announcement',
  templateUrl: './announcement.component.html',
})
export class AnnouncementComponent implements OnInit {
  @Input() data?: InfoBoxHtmlContent;

  // alert type classes: opt-critical-alert
  @Input() cardDescription: string = ``;
  @Input() cardBookingRefMessage: string = ``;
  @Input() cardContactInfo: string = ``;
  @Input() cardTitle: string = '';
  @Input() cssClass: string = 'opt-primary-alert';
  @Input() isButtonDefault: boolean = true;
  @Input() callOutSize: boolean = false;
  @Input() announcementIcon:string ='';

  //changed btnDecription to btnAvailable
  @Input() btnAvailable: boolean = false;
  @Input() onBtnClick: Function = () => {};

  sanitizedDescription: SafeHtml = '';
  sanitizedBookingRefMessage: SafeHtml = '';
  sanitizedContactInfo: SafeHtml = '';
  sanitizedTitle: SafeHtml = '';
  sanitizedHeaderIcon: SafeHtml = '';
  hasTitleContent: boolean = false;

  constructor(private sanitizer: DomSanitizer,private elementRef: ElementRef, private renderer: Renderer2) {}

  get computedCssClass(): string {
    return this.callOutSize
      ? `${this.cssClass} callout-announcment`
      : this.cssClass;
  }

  ngOnInit(): void {
    this.sanitizedDescription = this.sanitizer.bypassSecurityTrustHtml(
      this.data?.Description ?? this.cardDescription
    );
    this.sanitizedBookingRefMessage = this.sanitizer.bypassSecurityTrustHtml(
      this.data?.BookingRefMessage ?? this.cardBookingRefMessage
    );
    this.sanitizedContactInfo = this.sanitizer.bypassSecurityTrustHtml(
      this.data?.ContactInfo ?? this.cardContactInfo
    );
    const rawTitle = this.data?.Title ?? this.cardTitle ?? '';
    this.hasTitleContent = rawTitle.trim().length > 0;
    this.sanitizedTitle = this.sanitizer.bypassSecurityTrustHtml(rawTitle);
    this.sanitizedHeaderIcon = this.sanitizer.bypassSecurityTrustHtml(
      this.data?.Icon ?? this.announcementIcon
    );
    if (this.data && this.data.CssClass) {
      this.cssClass = this.data.CssClass;
    }
  }
}
